var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Môj profil")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profil.pouzivatel_id.farma_pouzivatela.length == 0 &&
                      _vm.profil.pouzivatel_id.kravicky_pouzivatela.length > 0
                        ? _c(
                            "span",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "vytvorenie-farmy" } } },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mb-3 main-banner",
                                    attrs: { src: "assets/img/banner.png" }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3"
                              },
                              [
                                _c(
                                  "h5",
                                  { staticClass: "a-profileCard__title" },
                                  [_vm._v("Môj album")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__value" },
                                  [_vm._v(_vm._s(_vm.albumProgress))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__description" },
                                  [_vm._v("odomknutých súčastí")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__button" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "btn --primary",
                                        attrs: { to: { name: "album" } }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Môj album\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3"
                              },
                              [
                                _c(
                                  "h5",
                                  { staticClass: "a-profileCard__title" },
                                  [_vm._v("Moje kravičky")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.profil.pouzivatel_id
                                          .kravicky_pouzivatela.length
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__description" },
                                  [
                                    _vm.profil.pouzivatel_id
                                      .kravicky_pouzivatela.length == 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                        adoptovaná kravička\n                                    "
                                          )
                                        ])
                                      : _vm.profil.pouzivatel_id
                                          .kravicky_pouzivatela.length > 1 &&
                                        _vm.profil.pouzivatel_id
                                          .kravicky_pouzivatela.length < 5
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                        adoptované kravičky\n                                    "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                        adoptovaných kravičiek\n                                    "
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__button" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "btn --primary",
                                        attrs: { to: { name: "kravicky" } }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Moje kravičky\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3"
                              },
                              [
                                _c(
                                  "h5",
                                  { staticClass: "a-profileCard__title" },
                                  [_vm._v("Moje správy")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__value" },
                                  [_vm._v(_vm._s(_vm.spravy))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__description" },
                                  [
                                    _vm.spravy == 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                        neprečítaná správa\n                                    "
                                          )
                                        ])
                                      : _vm.spravy > 1 && _vm.spravy < 5
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                        neprečítané správy\n                                    "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                        neprečítaných správ\n                                    "
                                          )
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "a-profileCard__button" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "btn --primary",
                                        attrs: { to: { name: "spravy" } }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Moje správy\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.showRuleta
        ? _c(
            "div",
            [
              _c("ruleta", {
                attrs: { profil: _vm.profil },
                on: { updateProfil: _vm.emitUpdateProfil }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }